import { useState, useRef } from "react";
import useIsMobile from "../../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../../hooks/usePageFillTableScroll";
import styles from "../Services.module.css";
import {
  Form,
  Input,
  message,
  Table,
  Tag,
  Typography,
} from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import tagStyles from "../../../../styles/Custom/Tag.module.css";
import { updateCategoryApi } from "../../../../services/service.services";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
const { Paragraph } = Typography;
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = <Input className={inputStyles?.mdInput} />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: record?.key === "name" && true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const CategoryTable = ({
  loading,
  data,
  setData,
  refreshPage,
  userDetails,
}) => {
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record?.id === editingKey?.id;

  const defaultRole = userDetails?.currRole || getCookie(Role);

  const edit = (record) => {
    form.setFieldsValue({
      name: "",
      protien: "",
      calories: "",
      ...record,
    });
    setEditingKey(record);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (record) => {
    try {
      const updatedValues = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => record.id === item.id);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...updatedValues });
        setData(newData);
        const res = await updateCategoryApi(record.id, updatedValues);
        refreshPage();
        message.success(res?.data?.message);
        setEditingKey("");
      } else {
        message.error("Row not found");
      }
    } catch (err) {
      console.error("Error:", err);
      message.error("Error updating medication");
    }
  };
  const columns = [
    {
      title: "Category Name",
      dataIndex: "name",
      editable: true,
      width: "15%",
      sorter: (a, b) => a?.name.localeCompare(b?.name),

      render: (value, record) =>
        record?.is_antiboitic ? (
          <Tag className={tagStyles.mdRndTag} color="magenta">
            {value}
          </Tag>
        ) : (
          value
        ),
    },
    {
      title: "Description",
      dataIndex: "description",
      editable: true,
      width: isMobile ? 200 : "20%",
      ellipsis: isMobile,
      sorter: (a, b) => {
        const descA = a?.description || "";
        const descB = b?.description || "";
        return descA?.localeCompare(descB);
      },
      render: (value) => (
        <Paragraph
          ellipsis={{
            rows: 2,
            expandable: true,
            symbol: "more",
          }}
          style={{ width: 320 }}
        >
          {value}
        </Paragraph>
      ),
    },

    ...(defaultRole === "Receptionist" || defaultRole === "Facility_Admin"
      ? []
      : [
          {
            title: "Action",
            dataIndex: "operation",
            width: "5%",
            render: (_, record) => {
              const editable = isEditing(record);
              return editable ? (
                <span>
                  <Typography.Link
                    onClick={() => save(record)}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    Save
                  </Typography.Link>
                  <Typography.Link
                    onClick={cancel}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    Cancel
                  </Typography.Link>
                </span>
              ) : (
                <Typography.Link
                  disabled={editingKey !== ""}
                  onClick={() => edit(record)}
                >
                  Edit
                </Typography.Link>
              );
            },
          },
        ]),
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div ref={tableWrapRef} className={`${styles.servicesTableWrap} ui-table-fill-body`}>
      <Form form={form} component={false}>
        <Table
          className="no-vertical-borders"
          rowKey={(record) => record.id}
          loading={loading}
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}
          scroll={tableScroll}
        />
      </Form>
    </div>
  );
};
export default CategoryTable;
